import {DomainObject} from 'shared/store';
import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';
import User from 'main/stores/users/User';

class InterviewSchedule extends DomainObject {
  templateName;
  calendarEventName;
  eventDescription;
  duration;
  location;
  address;
  phoneNumber;
  emailSubject;
  emailRichText;
  emailLexicalState;
  relativeEndDateUnit;
  relativeEndDateValue;
  minimumNoticeValue;
  minimumNoticeUnit;
  eventBuffer;
  timezone;
  availabilityWindows;
  interviewers = [];
  meetingHost;
  configuredAt;
  inUse;
  integrationsMissing;
  resolvedStartDate;
  resolvedEndDate;

  _relations = {
    _dates: ['resolvedStartDate', 'resolvedEndDate'],
    interviewers: [User],
    meetingHost: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      templateName: observable,
      calendarEventName: observable,
      eventDescription: observable,
      duration: observable,
      location: observable,
      address: observable,
      phoneNumber: observable,
      emailSubject: observable,
      emailRichText: observable,
      emailLexicalState: observable,
      relativeEndDateUnit: observable,
      relativeEndDateValue: observable,
      minimumNoticeValue: observable,
      minimumNoticeUnit: observable,
      eventBuffer: observable,
      timezone: observable,
      availabilityWindows: observable,
      interviewers: observable,
      meetingHost: observable,
      configuredAt: observable,
      inUse: observable,
      integrationsMissing: observable,
      resolvedStartDate: observable,
      resolvedEndDate: observable,
      addInterviewer: action,
      removeInterviewer: action
    });

    this.merge(other);
  }

  addInterviewer(user) {
    this.interviewers.push(user);
  }

  removeInterviewer(user) {
    _.remove(this.interviewers, {id: user.id});
  }
}

export default InterviewSchedule;
